/**
 * WordPress dependencies
 */
const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

/**
 * Internal dependencies
 */
import Edit from './edit'
import icon from './icon'

registerBlockType( 'razorpay/payment-button', {

	title:      'Razorpay: Payment Buttons',
	description: 'Select a button below to add it to your page.',
	category:    'text',
	attributes:  {
		buttonId:      {
			type: 'string',
		},
		title:       {
			type:    'boolean',
			default: true,
		},
		tabindex:    {
			type: 'string',
		},
		buttonPreview: {
			type:    'boolean',
			default: true,
		},
	}, 

	edit: Edit,

	save() {
		return (
			null
		);
	},

} );
